document.addEventListener('DOMContentLoaded', function () {
    var allPointsToggle = document.querySelector('.js-all-points-toggle');
    var allPointsModal = document.getElementById('allPoints');
    var allPointsCloseBtn = document.querySelector('.all-points__close');
    var allPointsItems = document.querySelectorAll('.js-all-points-item');
    var searchInput = document.querySelector('.js-all-points-search');
    var storesSelect = document.querySelector('.js-all-points-stores');
    var seriesSelect = document.querySelector('.js-all-points-series');
    var phoneItems = document.querySelectorAll('.all-points__item-phone');
    var siteItems = document.querySelectorAll('.all-points__item-site');

    if (allPointsToggle) {
        // Открытие и закрытие модального окна
        allPointsToggle.addEventListener('click', () => {
            allPointsModal.classList.add('all-points--opened');
            document.body.style.overflow = 'hidden'; // Отключаем прокрутку для body
        })

        allPointsCloseBtn.addEventListener('click', () => {
            allPointsModal.classList.remove('all-points--opened');
            document.body.style.overflow = ''; // Восстанавливаем прокрутку для body
        })

        // Обработка телефонов
        phoneItems.forEach(function (item) {
            var rawPhones = item.textContent.split(','); // Разделяем номера телефонов по запятой
            var links = rawPhones.map(function (phone, index) {
                phone = phone.replace(/\D/g, ''); // Удаляем все нецифровые символы

                // Проверка на минимальную длину номера (9 символов без учета кода страны)
                if (phone.length < 11) return ''; // Пропускаем пустые или некорректные номера

                // Форматируем телефон в нужный вид
                var formattedPhone = '+7 (' + phone.substring(1, 4) + ') ' + phone.substring(4, 7) + '-' + phone.substring(7, 9) + '-' + phone.substring(9, 11);

                // Заменяем label на отформатированный номер телефона
                var label = formattedPhone;
                return '<a href="tel:' + phone + '">' + label + '</a>'; // Создаем ссылку для каждого номера
            }).filter(Boolean); // Удаляем пустые строки из массива

            if (links.length > 0) {
                item.innerHTML = links.join(', '); // Объединяем ссылки в строку и устанавливаем как HTML-содержимое элемента
            } else {
                item.remove(); // Удаляем элемент, если нет валидных телефонов
            }
        });

        document.querySelectorAll('.js-show-map-button').forEach(function (button) {
            button.addEventListener('click', function () {
                allPointsModal.classList.remove('all-points--opened');
                document.body.style.overflow = ''; // Восстанавливаем прокрутку для body
            });
        });

        function filterItems() {
            var query = searchInput.value.toLowerCase();
            var selectedStore = storesSelect.value;
            var selectedSeries = seriesSelect.value;

            allPointsItems.forEach(function (item) {
                var dataName = item.getAttribute('data-item-name').toLowerCase();
                var dataDescription = item.getAttribute('data-item-description').toLowerCase(); // Получаем описание
                var dataStores = item.getAttribute('data-item-stores');
                var dataSeries = item.getAttribute('data-item-series').split(',').map(s => s.trim()); // Разбиваем строку на массив и удаляем пробелы

                var isMatchQuery = query ? dataName.indexOf(query) !== -1 || dataDescription.indexOf(query) !== -1 : true; // Проверяем имя или описание
                var isMatchStores = selectedStore !== '0' ? dataStores === selectedStore : true;
                var isMatchSeries = selectedSeries !== '0' ? dataSeries.includes(selectedSeries) : true; // Проверяем, содержит ли массив выбранное значение

                if (isMatchQuery && isMatchStores && isMatchSeries) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }
            });
        }


        searchInput.addEventListener('input', filterItems);
        storesSelect.addEventListener('change', filterItems);
        seriesSelect.addEventListener('change', filterItems);

    }
});